import { Component, Input } from '@angular/core';
import { ComponentWithCopy } from '../../intefaces/interfaces';
import { HeadlineLarge } from '../../components/typography/headline-large/headline-large';
import { BodyLarge } from '../../components/typography/body-large/body-large';
import { AnimateOnScroll } from 'primeng/animateonscroll'

@Component({
  selector: 'app-feature-with-sub-features-and-image',
  imports: [HeadlineLarge, BodyLarge, AnimateOnScroll],
  templateUrl: './feature-with-sub-features-and-image.html',
  styleUrl: './feature-with-sub-features-and-image.css'
})
export class FeatureWithSubFeaturesAndImage {
  @Input() content!: ComponentWithCopy

}
